common.View.create('canvas.blocks.sky.sliderBravo.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        this.element.find('.owl-carousel').owlCarousel({
            loop: true,
            dots: true,
            nav: false,
            autoplay: !this.element.is('[data-canvas-editable]'),
            autoplayTimeout: 7500,
            autoplayHoverPause: true,
            items: 1,
        });
    }
});
